module.exports = __webpack_public_path__ + "img/33_newYouth_zyf.fc53714d.png";